import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=0d7fe8c8&scoped=true&"
import script from "./EditorWrapper.vue?vue&type=script&lang=js&"
export * from "./EditorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=0d7fe8c8&scoped=true&lang=scss&"
import style1 from "./EditorWrapper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7fe8c8",
  null
  
)

export default component.exports